import { Container, Input, Button } from "components/atoms";
import { t } from "i18next";
import { PiImage, PiPlus } from "react-icons/pi";
import FormGrid from "../forms/wrappers/FormGrid";
import MerchImageCard from "../card/MerchImageCard";
import { getImageSize } from "utils/components/inputs/image";
import { PopupActions } from "reactjs-popup/dist/types";
import { useMemo } from "react";
import { useFormikContext } from "formik";

export interface GalleryImages {
  images: {
    imageId: string;
    imageLink: string;
    imagePreviewLink: string;
    isMain?: boolean;
  }[];
  pendingImages: File[];
  deleteImages: string[];
}

interface GalleryProps {
  showMainImageControls?: boolean;
  isMainImg: boolean;
}

const Gallery = <T extends { gallery: GalleryImages; mainImageId?: string }>({
  showMainImageControls = false,
  isMainImg,
}: GalleryProps) => {
  const { values, status, setFieldValue } = useFormikContext<T>();

  const gallery = values.gallery ?? {
    images: [],
    pendingImages: [],
    deleteImages: [],
  };

  const pendingImageUrls = useMemo(
    () =>
      gallery.pendingImages.map((file) => ({
        file,
        url: URL.createObjectURL(file),
      })),
    [gallery.pendingImages]
  );

  const handleAddImage = (
    croppedFile: File,
    actions: PopupActions,
    clearAllValues?: () => void
  ) => {
    console.log("Dodaję zdjęcie do pendingImages");
    console.log("Aktualne pendingImages:", gallery.pendingImages);
    const newPendingImages = [...gallery.pendingImages, croppedFile];
    setFieldValue("gallery.pendingImages", newPendingImages);
    console.log("Nowe pendingImages:", newPendingImages);
    actions.close();
    clearAllValues && clearAllValues();
  };

  const handleDeleteImage = (imageId: string) => {
    setFieldValue(
      "gallery.images",
      gallery.images.filter((image) => image.imageId !== imageId)
    );
    setFieldValue("gallery.deleteImages", [...gallery.deleteImages, imageId]);
  };

  const handleDeletePendingImage = (index: number) => {
    const newPendingImages = gallery.pendingImages.filter((_, i) => i !== index);
    setFieldValue("gallery.pendingImages", newPendingImages);
  };

  return (
    <Container className="self-start">
      <Container.Header
        title={
          <>
            <PiImage /> {t("merch.tabs.images")}
          </>
        }
      />
      <Container.Content>
        <FormGrid>
          {gallery.images.map((image) => (
            <MerchImageCard
              key={image.imageId}
              {...image}
              isMain={image.isMain}
              showMainImageControls={showMainImageControls}
              currentImage={values.mainImageId}
              displayMode={status?.displayMode}
              onDeleteImage={() => handleDeleteImage(image.imageId)}
              onMainImageIdChange={() =>
                setFieldValue("mainImageId", image.imageId)
              }
            />
          ))}
          {pendingImageUrls.map(({ file, url }, index) => (
            <MerchImageCard
              key={`pending-${index}`}
              imageId={`pending-${index}`}
              imageLink={url}
              showMainImageControls={showMainImageControls}
              imagePreviewLink={url}
              isMain={false}
              currentImage={values.mainImageId}
              displayMode={status?.displayMode}
              onDeleteImage={() => handleDeletePendingImage(index)}
              onMainImageIdChange={() => console.log("ustawiam main")}
            />
          ))}
          {!status?.displayMode && (
            <Input.Image
              key={`input-image-${gallery.pendingImages.length}`}
              imagePlaceholder={<PiPlus className="new" />}
              onSave={handleAddImage}
              editable={!status?.displayMode}
              imageSize={getImageSize(1500)}
              imageSizeSelectOptions={[
                { label: "1500 px", value: 1500 },
                { label: "2000 px", value: 2000 },
                { label: "2500 px", value: 2500 },
                { label: "3000 px", value: 3000 },
              ]}
            />
          )}
        </FormGrid>
      </Container.Content>
    </Container>
  );
};

export default Gallery;
